import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/weather-pulse", label: "Today", end: true, testid: "wp-nav-today" },
  { to: "/weather-pulse/live", label: "Live", testid: "wp-nav-live" },
  { to: "/weather-pulse/place", label: "My City", testid: "wp-nav-place" },
  { to: "/weather-pulse/map", label: "Map", testid: "wp-nav-map" },
  { to: "/weather-pulse/now", label: "Happening Now", testid: "wp-nav-now" },
  { to: "/weather-pulse/journal", label: "Journal", testid: "wp-nav-journal" },
  { to: "/weather-pulse/365", label: "365", testid: "wp-nav-365" },
  { to: "/weather-pulse/station", label: "Station", testid: "wp-nav-station" },
  { to: "/weather-pulse/schools", label: "Schools", testid: "wp-nav-schools" },
  { to: "/weather-pulse/learn", label: "Learn", testid: "wp-nav-learn" },
];

/** Slim tab bar rendered on every Weather Pulse page. */
export default function WeatherPulseNav() {
  return (
    <nav className="flex flex-wrap gap-2 mb-8" data-testid="wp-nav" aria-label="Weather Pulse">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          data-testid={t.testid}
          className={({ isActive }) =>
            "rounded-full px-4 py-1.5 font-mono-tech text-[10px] tracking-[0.24em] uppercase border transition-colors " +
            (isActive
              ? "bg-[#1B4332] text-[#F5EBDC] border-transparent"
              : "bg-white border-black/15 text-[#1B4332] hover:bg-black/5")
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
